import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, Grid, TablePagination, TextField, Typography } from "@mui/material";
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "routes";
import Footer from "pages/LandingPages/Author/sections/Footer";
import MKBox from "components/MKBox";
import bgImage from "../../assets/images/city-profile.jpg"
import { useState } from "react";
import { useEffect } from "react";
import { get } from "utility/fetch";
import { numberWithCommas } from "utility/general";
import DatePicker from "react-flatpickr";
import { post } from "utility/fetch";
import { CircleLoader, ClipLoader } from "react-spinners";
import notification from "utility/notification";
import EbanqoHelmet from "layouts/EbanqoHelmet";



export default function GenerateReports() {

    const [transactions, setTransactions] = useState([])
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dateTo, setDateTo] = useState(new Date())
    const [dateFrom, setDateFrom] = useState(new Date())
    const [stLoading, setStLoading] = useState(false);
    const [dwLoading, setDwLoading] = useState();

    const generateRSAStatement = async () =>{
        setStLoading(true)
        console.log(dateTo)
        console.log(new Date(dateTo).toISOString())
        let res = await get(`/estatement/${sessionStorage.getItem("pin")}/${new Date(dateFrom).toISOString()}/${new Date(dateTo).toISOString()}`);
        if(res?.data?.statusCode === 200){
            console.log(res);
            setStLoading(false)
            notification({
                title: "Success",
                message: res?.data?.message,
                type: 'success'
            })
        }
        else if (res.data.statusCode === 404) {
            //account not found
            console.log("here")
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 500) {
            //server error
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 503) {
            //service unavailable
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 426) {
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else{
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
    }
    

    const generateWelcomeLetter = async () =>{
        setDwLoading(true)
        let res = await post(`/welcome-letter/${sessionStorage.getItem("pin")}`);
        if(res){
            console.log(res);
            setDwLoading(false)
            notification({
                title: "Success",
                message: res?.data?.message,
                type: 'success'
            })
        }
        else if (res.data.statusCode === 404) {
            //account not found
            console.log("here")
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 500) {
            //server error
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 503) {
            //service unavailable
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else if (res.data.statusCode === 426) {
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        else{
            //notification
            notification({
                title: "error",
                message: res?.data?.message,
                type: 'danger'
            })
        }
        console.log(res);

    }




    // Calculate the number of pages needed
    const numberOfPages = Math.ceil(transactions?.length / rowsPerPage);

    // Get the items for the current page
    const paginatedItems = transactions.slice((page - 1) * rowsPerPage, page * rowsPerPage);

    const handleChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const getAllTransactions = async () => {
        let res = await get(`/all-customer-transactions/${sessionStorage.getItem('pin')}`)
        console.log(res)
        if (res.statusCode === 200 || res?.status === 200) {
            setTransactions(res?.data?.data)
        }
        else {
            console.log(res)
        }
    }


    useEffect(() => {
        getAllTransactions();
    }, [])




    return (
        <div style={{width:"100%"}}>
            <EbanqoHelmet />
            <DefaultNavbar
                routes={routes}
                action={{
                    type: "external",
                    route: "https://www.creative-tim.com/product/material-kit-react",
                    label: "free download",
                    color: "info",
                }}
                transparent
                light
            />
            <MKBox
                minHeight="10rem"
                width="100%"
                sx={{
                    backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
                        `${linearGradient(
                            rgba(gradients.dark.main, 0.8),
                            rgba(gradients.dark.state, 0.8)
                        )}, url(${bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "grid",
                    placeItems: "center",
                }}
            />



            <Typography sx={{ mt: 3 }} textAlign={"center"} variant="h4" >
                Statements and Reports
            </Typography>
            <Typography textAlign={"center"} variant="h5">
                All your pension documents
            </Typography>


            <Grid container sx={{ mb: 5, mt: 5 }} justifyContent={"center"} spacing={3}>
                <Grid item md={5} xs={10}>
                    <Card>
                        <CardContent>
                            <Typography textAlign={"start"} variant="h5" gutterBottom>RSA Statement</Typography>
                            <Typography textAlign={"start"} variant="body2">Generate Your RSA Statement</Typography>

                            <Box sx={{mt:2}}>
                                <Grid container spacing={2}>
                                    <Grid item xs={9}  lg={6} >
                                        <Typography variant="body2">From</Typography>
                                        <DatePicker
                                            // data-enable-time
                                            aria-label="From"
                                            style={{padding:'10px',width:"100%", borderRadius: '5px'}}
                                            value={dateFrom}
                                            onChange={([date]) => {
                                                setDateFrom(date);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={9}  lg={6}>
                                        <Typography variant="body2">To</Typography>
                                        <DatePicker
                                            // data-enable-time
                                            style={{padding: '10px', width:"100%", borderRadius: '5px'}}
                                            aria-label="To"
                                            value={dateTo}
                                            onChange={([date]) => {
                                                setDateTo(date);
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Button onClick={generateRSAStatement} disabled={stLoading}  sx={{mt:2, color:"black", backgroundColor:"#A6CE39", border:"1px solid #A6CE39", px:2, py:2}} variant="filled">
                               Generate RSA Statement {stLoading && <ClipLoader/> }
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item md={5} xs={10}>
                    <Card>
                        <CardContent>
                            <Typography textAlign={"start"} variant="h5" gutterBottom>Welcome Letter</Typography>
                            <Typography textAlign={"start"} variant="body2">Generate your welcome letter.</Typography>

                            <Box md={12} sx={{mt:10}}>
                              
                            </Box>
                            <Button onClick={generateWelcomeLetter} disabled={dwLoading} sx={{mt:2, color:"black", backgroundColor:"#A6CE39", border:"1px solid #A6CE39", px:2, py:2}} variant="filled">
                                Generate welcome letter {dwLoading && <ClipLoader />}
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>

            </Grid>




            


            <Footer />
        </div>
    );
}